import { Box, Text } from 'rebass';
import { MdFileDownload as DownloadIcon } from 'react-icons/md';
import { FaRegEdit, FaCut } from 'react-icons/fa';
import { RxDragHandleDots2 } from "react-icons/rx";
import { BiImages } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import Tippy from '@tippy.js/react';
// import EditVideoDropdownLink from 'story-media/video-editor/EditVideoDropdownLink';
import { BsThreeDots } from "react-icons/bs";
import { useDropzone } from 'react-dropzone';
import useSWR from 'swr';

import { useEntity } from 'entities/hooks';
import { EditButtonsWrap, MoreLink, MoreLinkAnchor } from './styled';
import { createMediaForFiles, destroyMedium, promptDestroyMedium } from './actions';
import { useToggle } from '../app/hooks';
// import EllipsisIcon from '../assets/svg/ellipsis-icon';
import MoveStoryPage from '../stories/edit-story/move';
import Modal from 'app/modal/v2/index';
import FileDropper from 'stories/tell-a-story/FileDropper';
import CoverPreview from 'stories/new/cover/preview';
import CoverEditor from 'stories/new/cover/editor';
import { updateTextMedium } from './api';
import { receiveEntity, updateEntity } from 'entities/actions';
import { useFFmpeg } from 'contexts/FFmpegContext';
import SplitStory from './split-story';

const EditButtons = ({ mediumType, storyId, pagePosition, pageId, id, isGrouped, ...props }) => {
  const promptingDestroy = useSelector(state => state.storyMedia.destroyPrompts.includes(storyId));
  const { entity: medium } = useEntity({ id, type: mediumType });
  const [on, toggle] = useToggle();
  const [splitPrompt, toggleSplitPrompt] = useToggle();
  const [replaceImage, setReplaceImage] = useToggle();
  const [imageToUpload, setImageToUpload] = useState()
  const [editingSrc, setEditingSrc] = useState(null);
  const [isCropping, setCropping] = useState(false);
  const dispatch = useDispatch();
  const { revalidate } = useSWR(`/v2/media/${id}`)

  // const submitMedia = useCallback(
  //   (files, transcribe) => dispatch(createMediaForFiles(storyId, files, pagePosition, false, transcribe)),
  //   [dispatch, pagePosition, storyId]
  // );
  const { ffmpeg } = useFFmpeg();

  const handleDrop = async dropped => {

    dispatch(createMediaForFiles(storyId, dropped, pagePosition, false, false, (media) => {

      dispatch(destroyMedium(id, pageId, mediumType, storyId))

      if (medium.caption)
        updateTextMedium(media.id, {
          data: {
            attributes: {
              caption: medium.caption,
              'lock-version': media?.['lock-version'],
            }
          }
        })
          .then((payload) => {
            revalidate()
            return payload;
          })
          .then((payload) => {
            dispatch(
              receiveEntity({ payload })
            );
            toggle()
          });
    }, ffmpeg));
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: e => handleDrop(e)
  });

  const { pathname } = useLocation();
  const { replace, push } = useHistory();
  const isFromBookCreation = pathname.includes('/book-creation')

  const getEditTextLink = () => {

    if (pathname.includes('new')) {
      if (pathname.includes('/tell_a_story'))
        return `/tell_a_story/new/${storyId}/edit/text/${id}`;

      return `/stories/new/${storyId}/edit/text/${id}`;
    }

    if (pathname.includes('/tell_a_story')) {
      return `/tell_a_story/story/${storyId}/edit/text/${id}`;
    }
    return `/story/${storyId}/edit/text/${id}`;
  };
  const textEditLink = mediumType === 'texts' ? getEditTextLink() : '';

  return (!promptingDestroy && (
    <EditButtonsWrap style={mediumType === 'audios' ? {
      position: 'relative',
      marginLeft: 'auto',
      marginBottom: '20px'
    } : {}}>{isFromBookCreation ? !pathname?.includes('?step=4') ?
      null
      : <button
        type="button"
        onClick={() => {
          push(`/story/${storyId}/edit?ref=${id}`, { from: `${window.location.href}&ref=${id}` })
        }}
        style={{
          padding: 0,
          border: 'none',
          background: '#fff',
          width: '38px',
          height: '38px',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <FaRegEdit color="#0E0E0E" size={24} />
      </button>
      :
      <Tippy
        trigger="manual"
        placement="bottom right"
        theme="light"
        interactive
        maxWidth="223px"
        // borderRadius="23px"
        visible={on}
        // style={{
        //   borderRadius: '10px 10px 0px 0px',
        //   background: '#F5EEF8'
        // }}
        content={
          <Box sx={{
            width: '223px',
            flexShrink: 0,
          }}>
            {textEditLink && (
              <MoreLink
                onClick={() => {
                  replace(textEditLink);
                  toggle();
                }}
              >
                <FaRegEdit color="#0E0E0E" size={20} />
                <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Edit</Text>
              </MoreLink>
            )}
            <MoveStoryPage.Consumer>
              {({ moveStoryPageId, setMoveStoryPage }) => (
                <MoreLink
                  onClick={() => {
                    setMoveStoryPage(pageId, pagePosition);
                    toggle();
                  }}
                  disabled={!!moveStoryPageId}
                >
                  <RxDragHandleDots2 size={20} />
                  <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Move</Text>
                </MoreLink>
              )}
            </MoveStoryPage.Consumer>

            {mediumType === 'images' && <Box {...getRootProps()}>
              <input {...getInputProps()} multiple={false} accept={'image/*'} />

              <MoreLink
                color="red"
                borderBottom="none"
                onClick={() => {
                  setReplaceImage()
                  toggle();
                }}
              >
                <BiImages size={20} />
                <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Replace Photo</Text>
              </MoreLink>
            </Box>}

            {!!medium['unprocessed-url'] && (
              <MoreLinkAnchor
                target="_blank"
                href={medium['unprocessed-url']}
                download={medium['unprocessed-url']}
                onClick={toggle}
              >
                <DownloadIcon size={20} />
                <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Download</Text>
              </MoreLinkAnchor>
            )}
            {/* {mediumType === 'videos' && <EditVideoDropdownLink videoId={id} />} */}
            <MoreLink
              onClick={() => {
                toggleSplitPrompt();
                toggle();
              }}
            >
              <FaCut size={20} color="#0E0E0E" />
              <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Split story from here</Text>
            </MoreLink>
            <MoreLink
              color="red"
              borderBottom="none"
              onClick={() => {
                props.promptDestroyMedium(id);
                toggle();
              }}
            >
              <RiDeleteBin6Line size={20} />
              <Text as="span" fontFamily="Poppins" color="#0E0E0E" fontSize={16} >Delete</Text>
            </MoreLink>
          </Box>
        }
      >
        <button
          type="button"
          onClick={toggle}
          style={{
            padding: 0,
            border: 'none',
            background: '#fff',
            width: '38px',
            height: '38px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <BsThreeDots color="#64748B" size={24} />
        </button>
      </Tippy>}
      {splitPrompt && <SplitStory storyId={storyId} pageId={pageId} onClose={toggleSplitPrompt} />}
    </EditButtonsWrap>
  )
  );
};

EditButtons.propTypes = {
  id: PropTypes.string.isRequired,
  storyId: PropTypes.string.isRequired,
  mediumType: PropTypes.string.isRequired,
  promptDestroyMedium: PropTypes.func.isRequired,
  pageId: PropTypes.string.isRequired,
  pagePosition: PropTypes.number.isRequired,
};

export default connect(null, { promptDestroyMedium })(EditButtons);
